<template>
  <div>
    <kst-input load-on-focus field="Name" :data="userData" :catalog="Catalog"/>
    <kst-input field="Alias" :data="userData" :catalog="Catalog"/>
    <kst-input field="Mobile" :data="userData" :catalog="Catalog"/>
    <kst-input field="Phone" :data="userData" :catalog="Catalog"/>
    <kst-input field="Email" :data="userData" :catalog="Catalog"/>
    <kst-input field="Comment" :data="userData" :catalog="Catalog"/>
  </div>
</template>

<script>
import Catalog from "../ClientCatalog.js";

export default {
  props: {
    userData: Object
  },
  data: () => ({
    Catalog: Catalog
  })
}
</script>